import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Directory from "@/pages/Directory";
import Register from "@/pages/Register";
import News from "@/pages/News";
import Events from "@/pages/Events";
import Exco from "@/pages/Exco";
import Login from "@/pages/Login";
import Verify from "@/pages/Verify";
import CulturalRunway from "@/pages/CulturalRunway";
import TicketVerify from "@/pages/TicketVerify";
import Dashboard from "@/pages/Dashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/register" element={<Register />} />
            <Route path="/news" element={<News />} />
            <Route path="/events" element={<Events />} />
            <Route path="/leadership" element={<Exco />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify/:membershipId" element={<Verify />} />
            <Route path="/cultural-runway" element={<CulturalRunway />} />
            <Route path="/verify-ticket/:ticketId" element={<TicketVerify />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
